import { html } from "lit-element";
import { render } from "lit-html";
import { angles } from "./photo-number-icons.js";
import { StatefulModule } from "../../ModuleBase/ModuleMetadata.js";

export class DrawPhotoNumber extends StatefulModule {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e), "Nr", this.direction);
		this.fireOnDraw();
	}

	static MakeAngle(pointer, direction = this.direction, text = "Nr") {
		const strShape = angles[direction](text).strings.reduce(a => a);
		let p = new Promise(resolve => {
			fabric.loadSVGFromString(strShape, function (objects, options) {
				var obj = fabric.util.groupSVGElements(objects, options);
				obj
					.scaleToHeight(20)
					.set({
						left: pointer.x,
						top: pointer.y,
						originY: "center",
						originX: "center"
					})
					.setCoords();
				resolve(obj);
			});
		});
		return p;
	}

	Draw(pointer, text = "Nr", direction) {
		let tempDiv = document.createElement("div");
		render(angles[direction](text), tempDiv);
		let svgString = tempDiv.innerHTML;
		tempDiv.remove();
		tempDiv = undefined;

		const canvas = this.canvas;
		fabric.loadSVGFromString(svgString, (objects, options) => {
			var obj = fabric.util.groupSVGElements(objects, options);
			if (direction === 'e' || direction === 'w')
				obj.scaleToWidth(50)
			else
			    obj.scaleToHeight(50)
			obj
				.set({ left: pointer.x, top: pointer.y })
				.setCoords();
			obj.selectable = true;
			this.addMetadata(obj, {
				direction: direction,
				text: text
			});

			canvas.add(obj);
			canvas.renderAll();
		});
	}

	render() {
		return html`
			<style>
				div {
					margin: 5px;
				}

				text {
					fill: var(--primary-color-variant1) !important;
				}
				
				path {
					stroke: var(--primary-color-variant1) !important;
				}
			</style>
			<div>${angles[this.direction]()}</div>`;
	}

	RenderSettings(obj, closeFunc) {
		const currentSettings = obj.moduleState;
		let tempNumber = currentSettings.text;

		const applyFunc = () => {
			this.applyNewSettings(obj, tempNumber);
			closeFunc();
		};

		return html`
            <style>
                .title {
                    font-size: x-large;    
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .button-box {
                    display: flex;
                    margin-top: 20px;
                }
            </style>
            <div class="title"> Photo angle settings</div>  
            <div>
               <text-box type="text" label="Number" 
                    @change="${e => (tempNumber = e.currentTarget.value)}"
                    .value="${currentSettings.text}"></text-box>
            </div>
            <div class="button-box">
                <mwc-button @click="${closeFunc}" label="Close"></mwc-button>
                <mwc-button @click="${applyFunc}}" label="Apply"></mwc-button>
            </div>`;
	}

	applyNewSettings(obj, text) {
		const currentSettings = obj.moduleState;
		if (currentSettings.text == text) return;

		this.addMetadata(obj, { text: text });
		obj._objects[1].set({ text: text });
		this.canvas.renderAll();
		this.canvas.trigger("object:modified", { target: obj });
	}

	static get properties() {
		return { direction: String };
	}

	constructor(canvas, direction) {
		super();
		this.canvas = canvas;
		this.direction = direction;
	}
}

window.customElements.define("inspx-draw-photo-number", DrawPhotoNumber);
